import { __assign } from "tslib";
import { createFeaturedArticlesApi, featuredArticlesApiRelativePath } from './index';
import { createHttpTestKit } from '../../../http/test-kit';
import { createFakeGetResponder, createFakePutResponder } from './../../../test-utils';
export var createFeaturedArticlesApiTestKit = function () {
    var fakeHttp = createHttpTestKit();
    var api = createFeaturedArticlesApi('', fakeHttp);
    // @ts-ignore - Ignore the error here, or handle wildcard ('*') param
    var testKit = {
        whenGetFeaturedArticles: function (dto) {
            return createFakeGetResponder(fakeHttp, featuredArticlesApiRelativePath + "/" + dto.locale);
        },
        whenUpdateFeaturedArticles: function (dto) {
            // tslint:disable-next-line:max-line-length
            return createFakePutResponder(fakeHttp, featuredArticlesApiRelativePath + "/" + dto.locale)(dto.data);
        }
    };
    return __assign(__assign({}, api), testKit);
};
//# sourceMappingURL=testkit.js.map